import type { FC, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { canAccessCustomers } from "../auth/auth";
import { useAuthContext } from "../auth/AuthContext";

const RequireCustomersAccess: FC<PropsWithChildren> = ({ children }) => {
  const { context } = useAuthContext();
  if (canAccessCustomers(context)) {
    return children;
  }
  return <Navigate to="/not-found" replace />;
};

export default RequireCustomersAccess;
